"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Left = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var useStyles = (0, _core.makeStyles)(function () {
  return {
    root: {
      transform: 'rotate(0)',
      '-webkit-transform': 'rotate(0)',
      '-moz-transform': 'rotate(0)',
      '-ms-transform': 'rotate(0)',
      '-o-transform': 'rotate(0)'
    }
  };
});

var Left = function Left(props) {
  var classes = useStyles(props);
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({
    classes: classes
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.0057983,19.0041084 C14.7399953,19.0056284 14.4845172,18.9012781 14.2957983,18.7140916 L8.29579832,12.7140916 C8.10648567,12.526325 8,12.2707292 8,12.0040916 C8,11.7374541 8.10648567,11.4818582 8.29579832,11.2940916 L14.2957983,5.29409163 C14.6879205,4.90196946 15.3236762,4.90196946 15.7157983,5.29409163 C16.1079205,5.6862138 16.1079205,6.32196946 15.7157983,6.71409163 L10.4157983,12.0040916 L15.7157983,17.2940916 C15.905111,17.4818582 16.0115966,17.7374541 16.0115966,18.0040916 C16.0115966,18.2707292 15.905111,18.526325 15.7157983,18.7140916 C15.5270795,18.9012781 15.2716013,19.0056284 15.0057983,19.0041084 Z"
  }));
};

exports.Left = Left;